export default {
  config: null,
  categories: [],
  lastTest: null,
  lastStockSync: null,
  busyCategoryIds: {},
  loadingCategories: false,
  loadingConfig: false,
}
